export type DefaultValueOrFactory<T> = T | (() => T);

function isFactory<T>(value: unknown): value is () => T {
    return typeof value === 'function';
}

export function getDefaultValue<T>(value: DefaultValueOrFactory<T>): T {
    if (isFactory<T>(value)) {
        return value();
    }

    return value;
}
